import { cn } from "@reactive-resume/utils";

type props = {
  score: number;
  size?: "small" | "regular";
  className?: string;
};

export const ScorePercentage = ({ score, size = "regular", className }: props) => {
  return (
    <div
      className={cn(
        "rounded-lg bg-gradient-to-r from-[#e1ff9e] to-[#a1f7ac] px-2 py-1 font-semibold text-green-600",
        Number(score) <= 60 && "bg-gradient-to-r from-[#f7e5ab] to-[#ffc6b5] text-orange-600",
        size === "small" && "px-2 py-1 text-xs",
        className
      )}
    >
      {`${score} %`}
    </div>
  );
};

